/*
 * Layout Name: Category Grid
 * Desc:
 */
import React from "react"
import { connect } from "react-redux"
import { useRouter } from "next/router"
import * as styles from "./ServiceGrid.module.scss"
// components
import SiteWrapper from "@components/structure/SiteWrapper/SiteWrapper"

const ServiceGrid = ({ services, staticData, inModal }) => {
  const router = useRouter()
  const handleSubmit = (event) => {
    router.push(
      `/suppliers-search/?loading=true&orderServices=true&services=["${event.target.value}"]`
    )
  }
  const servicesList = services && services.length ? services : staticData.serviceOptions

  const servicesElement =
    servicesList && servicesList.length
      ? servicesList.map((service) => {
          const layout = (
            <>
              <span>{service.label}</span>
              <div className={styles.images}>
                {service.icon ? <img src={service.icon.url} alt={service.label} /> : null}
              </div>
            </>
          )

          return service ? (
            <li key={service.value} className={styles.box}>
              <input
                type="checkbox"
                name={service.label}
                id={service.value}
                value={service.value}
                onChange={handleSubmit}
              />
              <label htmlFor={service.value}>{layout}</label>
            </li>
          ) : null
        })
      : null
  return (
    <section className={`${styles.ServiceGrid} ${inModal && styles.inModal}`}>
      <SiteWrapper full>
        <ul className={styles.grid}>{servicesElement}</ul>
      </SiteWrapper>
    </section>
  )
}

const mapStateToProps = (state) => ({
  staticData: state.staticData.data,
})

export default connect(mapStateToProps)(ServiceGrid)
